import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Radio } from "@alm/flow-ds/components";
import { OnApplyProps } from "elements/types";
import { ChangeEvent } from "react";
import { useSelector } from "react-redux";
import { State } from "data";
import { createGetElementData } from "data/form/elementSelectors";
import { RadioElement } from "records/Element";
import { useStandardElement } from "components/Forms/Element";
import { DisplayOnlyValue } from "elements";
import { ElementComponentData } from "../../data/form/elementSelectors";

function RadioOnApply({
	fid,
	vid,
	id,
	index,
	indexes,
	rowIndex,
	uuid,
	hint,
	label,
	required,
	disabled,
	options,
	displayOnly,
	isApplyClicked,
	fieldsIsEditedStatus,
	setFieldsIsEditedStatus,
}: OnApplyProps<RadioElement>) {
	const getData = useMemo(createGetElementData, []);
	const selectorProps = useMemo(
		() => ({ fid, vid, id, index, indexes, rowIndex, uuid }),
		[fid, vid, id, index, indexes, rowIndex, uuid]
	);
	const data = useSelector((state: State) =>
		getData(state, selectorProps)
	) as ElementComponentData<string>;
	const { eid, setDataAndQueue } = useStandardElement(selectorProps);

	const [value, setValue] = useState((data && data.value) || "");

	const handleOnChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			setValue(event.target.value);
			setFieldsIsEditedStatus(prev => ({ ...prev, [uuid]: true }));
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	useEffect(() => {
		if (isApplyClicked && fieldsIsEditedStatus[uuid]) {
			setDataAndQueue(data, {
				id,
				value,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isApplyClicked]);

	const opts = useMemo(() => {
		interface Option {
			value: string;
			label: string;
			disabled?: boolean;
			selected?: boolean;
		}
		const formatOptions: Option[] = options.map((option: string) => {
			return { value: option, label: option };
		});

		return options.indexOf(value) === -1 || value
			? formatOptions
			: [
					{
						value: value,
						label: value,
						disabled: true,
						selected: true,
					},
					...formatOptions,
			  ];
	}, [options, value]);

	// Display only
	if (displayOnly) {
		return <DisplayOnlyValue label={label} value={value} />;
	}

	return (
		<Radio
			id={eid}
			value={value}
			hint={hint}
			feedback={data.feedback}
			required={required}
			label={label}
			disabled={disabled}
			status={data.status}
			options={opts}
			onChange={handleOnChange}
		/>
	);
}

export default React.memo(RadioOnApply);
